class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.tapThroughBlocker = null;
    this.closeTransitionTimer = null;
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close(evt));
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
      overlay.addEventListener('pointerdown', this.close.bind(this));
      overlay.addEventListener('touchend', this.close.bind(this), { passive: false });
    }
    this.addEventListener('pointerdown', this.handleCloseControlEvent.bind(this), true);
    this.addEventListener('touchend', this.handleCloseControlEvent.bind(this), { capture: true, passive: false });
    this.addEventListener('click', this.handleCloseControlEvent.bind(this), true);
    this.setHeaderCartIconAccessibility();
  }

  getCartController(method) {
    try { const c = window.BizDecksCart; return typeof c?.isReady === 'function' && c.isReady() === true && typeof c[method] === 'function' ? c : null; } catch (_) { return null; }
  }

  consumeCloseEvent(event) {
    if (!event) return;
    if (typeof event.preventDefault === 'function') event.preventDefault();
    if (typeof event.stopPropagation === 'function') event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  }

  handleCloseControlEvent(event) {
    if (!event || !event.target || !event.target.closest('.drawer__close')) return;
    this.close(event);
  }

  blockTapThroughDuringClose() {
    if (this.tapThroughBlocker) return;

    this.tapThroughBlocker = (event) => {
      if (!document.documentElement.classList.contains('bd-cart-drawer-closing')) return;
      this.consumeCloseEvent(event);
    };

    this.addEventListener('click', this.tapThroughBlocker, true);
    this.addEventListener('pointerup', this.tapThroughBlocker, true);
    this.addEventListener('touchend', this.tapThroughBlocker, { capture: true, passive: false });
  }

  releaseTapThroughBlocker() {
    if (!this.tapThroughBlocker) return;

    this.removeEventListener('click', this.tapThroughBlocker, true);
    this.removeEventListener('pointerup', this.tapThroughBlocker, true);
    this.removeEventListener('touchend', this.tapThroughBlocker, true);
    this.tapThroughBlocker = null;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.getCartController('open')) {
        window.BizDecksCart.open({ trigger: cartLink }).catch(() => {});
        return;
      }
      window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        if (this.getCartController('open')) {
          window.BizDecksCart.open({ trigger: cartLink }).catch(() => {});
          return;
        }
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');;
      }
    });
  }
  open(triggeredBy, options = {}) {
    try { if (this.getCartController('noteOpen') && !options.coordinator) window.BizDecksCart.noteOpen(triggeredBy); } catch (_) {}
    this.openSequence = (this.openSequence || 0) + 1;
    const openSequence = this.openSequence;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    window.clearTimeout(this.closeTransitionTimer);
    this.releaseTapThroughBlocker();
    this.classList.remove('bd-cart-drawer-closing');
    document.documentElement.classList.remove('bd-cart-drawer-closing');
    this.setAttribute('aria-hidden', 'false');
    this.querySelectorAll('#CartDrawer, .drawer__inner').forEach((el) => el.setAttribute('aria-hidden', 'false'));
    this.querySelectorAll('#CartDrawer-Overlay, .cart-drawer__overlay').forEach((el) => el.setAttribute('aria-hidden', 'true'));
    document.documentElement.classList.add('bd-cart-drawer-open');
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.classList.add('animate', 'active');
    requestAnimationFrame(() => {
      if (openSequence !== this.openSequence || this.getAttribute('aria-hidden') !== 'false') return;
      if (this.querySelector('subcart-drawer')) this.querySelector('subcart-drawer').openSubDrawer();
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      if (openSequence === this.openSequence && this.getAttribute('aria-hidden') === 'false' && containerToTrapFocusOn && typeof trapFocus === 'function') trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close(event) {
    this.openSequence = (this.openSequence || 0) + 1;
    try { if (this.getCartController('noteClosed')) window.BizDecksCart.noteClosed(); } catch (_) {}
    const scrollY = window.scrollY || window.pageYOffset || 0;
    this.consumeCloseEvent(event);
    window.clearTimeout(this.closeTransitionTimer);
    this.blockTapThroughDuringClose();
    this.classList.add('bd-cart-drawer-closing');
    document.documentElement.classList.add('bd-cart-drawer-closing');

    if(this.querySelector('subcart-drawer')) this.querySelector('subcart-drawer').closeSubDrawer();
    this.classList.remove('active', 'is-open');
    this.removeAttribute('open');
    this.setAttribute('aria-hidden', 'true');
    this.querySelectorAll('#CartDrawer, .drawer__inner, #CartDrawer-Overlay, .cart-drawer__overlay, .cart-drawer').forEach((el) => {
      el.classList.remove('active', 'is-open');
      el.removeAttribute('open');
      el.setAttribute('aria-hidden', 'true');
    });
    removeTrapFocus();
    if (this.activeElement && typeof this.activeElement.focus === 'function') {
      try {
        this.activeElement.focus({ preventScroll: true });
      } catch (error) {
        this.activeElement.focus();
        window.scrollTo(0, scrollY);
      }
    }
    document.body.classList.remove('overflow-hidden', 'cart-drawer-open', 'cart-open');
    document.documentElement.classList.remove('bd-cart-drawer-open', 'overflow-hidden');
    document.dispatchEvent(new CustomEvent('cart:close'));
    this.closeTransitionTimer = window.setTimeout(() => {
      this.classList.remove('bd-cart-drawer-closing', 'animate', 'active', 'is-open');
      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('bd-cart-drawer-closing', 'bd-cart-drawer-open', 'overflow-hidden');
      document.body.classList.remove('overflow-hidden', 'cart-drawer-open', 'cart-open');
      this.releaseTapThroughBlocker();
      document.dispatchEvent(new CustomEvent('cart:closed'));
    }, 350);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (!parsedState) return false;
    if (this.getCartController('render')) return window.BizDecksCart.render(parsedState);
    // Keep a working native destination when the enhanced drawer cannot render.
    window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    return true;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class SubCartDrawer extends HTMLElement {
  constructor() {
    super();
  }

   closeSubDrawer(){
    this.classList.remove('active')
  }

  openSubDrawer(){
    this.classList.add('animate', 'active')
  }
}

customElements.define('subcart-drawer', SubCartDrawer);
 
